export default "__VITE_ASSET__BhvUgDik__"